export default "__VITE_ASSET__i$v9GY03__"